import React from "react";
import DoneIcon from "@mui/icons-material/Done";
import styles from "./TechStack.module.css";
import logo from "../../Assets/assetsnew/frontend_logo_with_name.webp";
import ClickUp from "../../Assets/frontendImages/clickup.png";
import Clockify from "../../Assets/frontendImages/clockify.png";
import DocuDesign from "../../Assets/frontendImages/docudesign.png";
import Invoicely from "../../Assets/frontendImages/invoicely.png";
import PipeDrive from "../../Assets/frontendImages/pipedrive.png";
import Xero from "../../Assets/frontendImages/xero.png";
import Line from "../../Assets/frontendImages/line.svg";
import { Link } from "react-router-dom";
import Heading from "./Heading";
import Description from "./Description";
import Colors from "../../Constants/Colors";

const TOOLS = [
  { img: ClickUp, desc: 'Tasks & Projects', alt: "ClickUp", price: "$7 user/month" },
  { img: Clockify, desc: 'Time Tracking', alt: "Clockify", price: "$8 user/month" },
  { img: DocuDesign, desc: 'Sign Contracts', alt: "Docu-design", price: "$25 user/month" },
  { img: Invoicely, desc: 'Invoicing', alt: "Invoicely", price: "$10 user/month" },
  { img: PipeDrive, desc: 'CRM & Client Tracking', alt: "Pipe drive", price: "$49 user/month" },
  { img: Xero, desc: 'Accounting', alt: "Xero", price: "$7 user/month" },
];

const FEATURES = [
  "Task Management",
  "Project Management",
  "Invoices & Receipts",
  "Time Tracking",
  "Contact Management",
  "Manage Finances",
  "Detailed Financial Statements",
  "Comprehensive Productivity Reports"
];

function TechStack() {
  return (
    <div
      className="container-fluid py-4 py-md-5 px-3 px-md-4 pm-sm-0"
      style={{ maxWidth: "1200px" }}
      data-aos="fade-up"
    >
      <div className="text-center mb-4">
        <Heading className="mb-3">
          Simplify Your Tech Stack
        </Heading>
        <Description className=" mx-auto mb-3">
          Juggling multiple tools for projects, billing, and reporting?<br /> Zodot replaces them all with one unified system, saving you time, money, and endless switching.
        </Description>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center flex-lg-row mt-5 gap-4 gap-lg-0">
        <div className="col-lg-5 col-md-6 col-sm-8 col-12">
          {TOOLS.map((t) => (
            <div
              key={t.alt}
              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center mb-3 rounded-3"
              style={{ textDecoration: "none", padding: "1rem", boxShadow: "0px 0px 5px 3px rgba(199, 204, 221, 0.3)" }}
            >
              <div>
              <img
                style={{ maxHeight: "2rem" }}
                src={t.img}
                alt={t.alt}
                className="me-2 mb-1"
                />

                <p className="m-0 text-xs">({t.desc})</p>
              </div>
              <Description className={styles.price}>{t.price}</Description>
            </div>
          ))}
        </div>

        <div className="d-none d-lg-block col-auto">
          <img src={Line} alt="Logo" style={{ width: "100%" }} />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-8 col-12">
          <div
            className="card text-white"
            style={{
              backgroundColor: Colors.bgColorFrontend,
              borderRadius: "15px",
            }}
          >
            <div className="card-body" style={{ padding: "35px 24px" }}>
              <img
                src={logo}
                alt="Logo"
                width={170}
                height={50}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "contain",
                  marginBottom: "10px",
                }}
              />
              <Description className="mt-2 mb-2 text-white text-start">
                Projects, tracking, finances and reporting in one system.
              </Description>
              <h3 className="text-white">
                $0.00{" "}
                <small className="text-white" style={{ fontSize: "14px" }}>
                  user/month
                </small>
              </h3>
              <Link
                to="/db/signup"
                className={styles.btn_begin}
              >
                {" "}
                Try for free
              </Link>
              <p className="text-white text-start small mt-2">
                Free for all users, no credit card required.
              </p>
              <ul className="list-unstyled mt-3 mb-0">
                {FEATURES.map((text) => (
                  <li
                    key={text}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "24px",
                        display: "flex",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginTop: "2px",
                      }}
                    >
                      <DoneIcon
                        sx={{
                          fontSize: 20,
                          color: Colors.brandColorFrontend,
                        }}
                      />
                    </div>

                    <Description className="text-white">
                      {text}
                    </Description>
                  </li>

                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TechStack;
